import {takeLatestF, putAll} from '@fl/cmsch-fe-library';
import {uniqBy} from 'lodash/fp';
import {SagaIterator} from 'redux-saga';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {simpleAnimalBrowserSelector} from 'app/animal-browser/model/selector';
import {cabFilterFormName} from 'app/animal-browser/types/cab-filter-form-values';
import {genFarmOptions} from 'app/animal-browser/utils/gen-options';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {animalBrowserAction, GetFarmOptionsAction} from '../action';

const tt = t('animalBrowser');

function* execute({payload}: GetFarmOptionsAction): SagaIterator {
    const selectedValues = (yield* select(formHelpers.formValues(cabFilterFormName))).prop('farmIds').orElse([]);
    const oldOptions = (yield* select(simpleAnimalBrowserSelector.farmOptions)).orElse([]);
    const selectedOptions = oldOptions.filter(option => selectedValues.includes(option.value));

    yield* put(animalBrowserAction.setLoading('farmsSearch', true));

    const response = yield* call(Api.getCabFarmsAutocompleteList, {text: payload});
    if (response.isSuccess) {
        yield* put(animalBrowserAction.getFarmOptionsSuccess(
            uniqBy('value', [...selectedOptions, ...genFarmOptions(response.data)]),
        ));
    } else {
        yield putAll(showBeError(response, tt('filter')));
    }

    yield* put(animalBrowserAction.setLoading('farmsSearch', false));
}

/**
 * Loads farm autocomplete options for the comprehensive filters.
 *
 * @returns The saga watcher for farm option requests.
 */
export function* getFarmOptionsSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_FARM_OPTIONS', execute);
}
